module.exports = __webpack_public_path__ + "img/horizontal_logo.8a7eb46b.png";